function confirmManualNotification(name, unit, receiverphone, receivermail, content, sendtext, sendemail, external, residentCount) {

    swal({
        title: "Confirmation",
        text: "Are you sure you want to send the following " + (sendtext ? "text" : "") + (sendtext & sendemail ? " and " : " ") + (sendemail ? "email" : "") +
            ": \n\n" + content + "\n\nTo: " + (external ? "" : name + " (" + unit + ")\n") + (sendtext ? receiverphone : "") + "\n" + (sendemail ? receivermail : "") + "\n",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-success",
        confirmButtonText: "Yes, send.",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnSendManualNotificationConfirmed', '-');


            swal("Notification" + (sendtext & sendemail ? "s" : "") + " sent", "See the archive page to see a list of all sent notifications", "success");

        });
}